import {PackageTypes, PackageTypes_Reverse, getDirectionInTier2} from "../dataStore/FilterDataStore"
import {getFeatureStatus, getNodeCapabilityList} from "../CommonUtils";
import {FEATURES} from "../constants/CommonConstants";

export const FilterConverter = async (filter, view, leg, statusToDirectionMap, state, packageStatus, isCPTFilterEnabled) => {

    var filterMap = {};
    var rangeFilterMap = {};

    if (view !== "AGEING_VIEW" && view !== "RTS_VIEW" && view !== "DWELLING_VIEW" && view !==  "SD_DWELLING_VIEW"
            && filter.lastUpdatedStart === "" && filter.lastUpdatedEnd === "") {

        filterMap["DWELL_TIME"] = [(filter.dwellEnd !== "" ? filter.dwellEnd : 0) + "_" + filter.dwellEndTimeUnit.toUpperCase(),  
        (filter.dwellStart !== "" ? filter.dwellStart : 1440) + "_" + filter.dwellStartTimeUnit.toUpperCase()]
    }

    if (!isCPTFilterEnabled && filter.cycles.length > 0 ) {

        filterMap["CYCLE"] = filter.cycles.map(cycle => { return cycle});

    }

    if (isCPTFilterEnabled && filter.CPT.length > 0 ) {

        filterMap["DISPATCH_BY"] = filter.CPT.map(CPTDetail => {return CPTDetail});

    }

    if (filter.deliveryWindow.length > 0 ) {

        filterMap["DELIVERY_WINDOW"] = filter.deliveryWindow.map(deliveryWindow => { return deliveryWindow});

    }

    const isDepartFilteringEnabled = await getFeatureStatus(FEATURES.DEPART_FILTERING_ENABLED)
    if(isDepartFilteringEnabled) {
        if ((view === "AGEING_VIEW" || view === "RTS_VIEW") && leg === "REVERSE") {
            const nodeCapability = await getNodeCapabilityList();
            if (!nodeCapability || nodeCapability ==="[]" || nodeCapability.includes("AMZL_CORE")) {
                filterMap["SOURCE_NODE"] = ["CHILD"];
                filterMap["DESTINATION_NODE"] = ["SELF"];
            } else if (nodeCapability.includes("HANDOVER")) {
                filterMap["SOURCE_NODE"] = ["SELF"];
                filterMap["DESTINATION_NODE"] = ["PARENT"];
            }
        }
    }

    var statusList = state ? [state] : packageStatus;

    //Map of status and list of directions
    if (statusList.length > 0 ) {
            
        statusList.forEach( status => {
                let packageState = status.split(" (", 1)[0];
    
                //Case 1 : Direction in tier 1
                if(status.split(" (", 2)[1] !== undefined) {

                    statusToDirectionMap[packageState] = statusToDirectionMap[packageState] ? statusToDirectionMap[packageState].concat([status.split(" (", 2)[1].split(")", 1)[0]]): [status.split(" (", 2)[1].split(")", 1)[0]]; 
                } else {

                   var direction = getDirectionInTier2(leg, status)
                   statusToDirectionMap[packageState] = direction.split(" (", 2)[1] !== undefined ? 
                        [direction.split(" (", 2)[1].split(")", 1)[0]]: [];
                }
            });
        }

    //Check for both filters
    if (filter.startPDD || filter.endPDD) {

        rangeFilterMap["EAD"] = {
            "startTime" : filter.startPDD ? new Date(filter.startPDD).getTime() / 1000 : new Date(filter.endPDD).getTime() / 1000,
            //Passing same PDD in case end pdd is not selected
            "endTime" : filter.endPDD ? new Date(filter.endPDD).getTime() / 1000 : new Date(filter.startPDD).getTime() / 1000
        }
    }
    //Check for both filters
    if (filter.shipDateStart || filter.shipDateEnd) {

        rangeFilterMap["SHIP_DATE"] = {
            "startTime" : filter.shipDateStart ? new Date(filter.shipDateStart).getTime() / 1000 : new Date(filter.shipDateEnd).getTime() / 1000,
            "endTime" : filter.shipDateEnd ? new Date(filter.shipDateEnd).getTime() / 1000 : new Date(filter.shipDateStart).getTime() / 1000
        }
    }

    if (filter.sameDay) {

        filterMap["SAME_DAY"] = [filter.sameDay.toString()]
    }

    if (leg) {
        
        if (leg === "FORWARD") {

            filterMap["SHIPMENT_TYPE"] = ["Delivery"]
         } 
    }

    if (filter.packageTypes.length > 0) {

        //Adding for dwelling
        filterMap["SHIPMENT_TYPE"] = [].concat.apply([], filter.packageTypes.map(packageType => {return PackageTypes[packageType]}));

    }

    if (filter.packageTypes_Reverse.length > 0) {

        //Adding for reverse leg in Ageing
         var displayShipType = [].concat.apply([], filter.packageTypes_Reverse.map(packageType => {return PackageTypes_Reverse[packageType]}));
         filterMap["SHIPMENT_TYPE"] = [].concat.apply([], displayShipType.map(shipType => {return PackageTypes[shipType]}))

    }

    if (filter.stationArrivalTime.length > 0) {

        filterMap["LOCAL_STATION_ARRIVAL_TIME"] = filter.stationArrivalTime;
    }

    if (filter.eadSection) {

        filterMap["EAD_SECTION"] = ["true"];
    }

    if (filter.shipOption) {
        filterMap["SHIPMENT_OPTION"] = filter.shipOption;
    }

    return [{
        "__type" : "TermFilter:http://internal.amazon.com/coral/com.amazon.oculusservice.model.filter/"
        ,"filterMap": filterMap},{

        "__type" : "RangeFilter:http://internal.amazon.com/coral/com.amazon.oculusservice.model.filter/"
        ,"filterMap": rangeFilterMap

    }]
}


// WEBPACK FOOTER //
// ./src/commons/filter/FilterConverter.js